import type React from 'react'

/**
 * Merges multiple refs (functions or RefObjects) into a single stable ref callback.
 * Filters out null / undefined entries.
 */
export function mergeRefs<T>(refs: Array<React.Ref<T> | null | undefined>): React.RefCallback<T> {
  return (value: T | null) => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(value)
      } else if (ref != null) {
        ;(ref as React.MutableRefObject<T | null>).current = value
      }
    }
  }
}
